'use strict'

module.exports = {
  app: require('./app'),
  biz: require('./biz')
}
